/** @file Playback FSM: idle | playing | paused. */

/** @typedef {"idle" | "playing" | "paused"} PlaybackState */
/** @typedef {"play" | "pause" | "reset"} PlaybackEvent */

/** @type {Record<PlaybackState, Partial<Record<PlaybackEvent, PlaybackState>>>} */
const TABLE = {
  idle: { play: "playing" },
  playing: { pause: "paused", reset: "idle" },
  paused: { play: "playing", reset: "idle" },
};

export function createPlaybackFSM() {
  /** @type {PlaybackState} */
  let state = "idle";
  /** @type {Set<(s: PlaybackState) => void>} */
  const listeners = new Set();

  /**
   * @param {PlaybackEvent} ev
   * @returns {boolean} whether transition happened
   */
  function dispatch(ev) {
    const next = TABLE[state]?.[ev];
    if (!next || next === state) {
      return false;
    }
    state = next;
    for (const fn of listeners) {
      fn(state);
    }
    return true;
  }

  /** @param {(s: PlaybackState) => void} fn */
  function subscribe(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
  }

  return {
    /** @returns {PlaybackState} */
    get state() {
      return state;
    },
    dispatch,
    subscribe,
  };
}
